<template>
  <div class="wrap">
    <el-container>
      <el-header class="wrap-header" height='70px'>
        <div class="wrap__img-epson">
          <img :src="logo_img" alt="EPSON" width="110" height="40">
        </div>
        <div class="header-title" v-show="this.homebut()">
          <span>{{$t('T_TOP_TITLE')}}</span>
        </div>
        <div class="header-version" v-show="this.homebut()">
          <span>v{{ version }}</span>
        </div>
        <div class="wrap__theme" v-show="this.homebut()">
          <el-checkbox v-model="themeLight" @change="changeThemeLight" class="wrap__theme_light"></el-checkbox>
          <el-checkbox v-model="themeDark" @change="changeThemeDark" class="wrap__theme_dark"></el-checkbox>
        </div>
        <div class="wrap__language">
          <el-select
            v-model="value"
            @change="languagechange"
            popper-class='language-select'
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </el-header>
    </el-container>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'Header',
  data () {
    return {
      logo_img: require('../assets/parts/logo.png'),
      // options: this.languageOptions,
      // value: Vue.prototype.InitConfig.initLanguage,
      // verMajor: 2,
      // verMinor: 0,
      // verMinor2: 3,
      // verDate: '20201116',
      // verPhase: '(alpha)', // base|alpha|beta|RC|release,
      themeLight: true,
      themeDark: false,
      languageData: 'el'
    }
  },
  computed: {
    ...mapState([
      'isUSTWall', 'languageOptions', 'languageDefault', 'versionInfo', 'languageFlag'
    ]),
    version () {
      return this.versionInfo.verMajor + '.' +
              this.versionInfo.verMinor + '.' +
              this.versionInfo.verMinor2 + '.' +
              this.versionInfo.verDate +
              this.versionInfo.verPhase
    },
    options: {
      get () {
        return this.languageOptions
      }
    },
    value: {
      set (val) {
        this.SET_LANGUAGEDEFAULT(val)
      },
      get () {
        return this.languageDefault
      }
    }
  },

  created () {
    // if (this.InitConfig.initMain === 1) {
    if (!this.languageFlag) {
      const lang = this.InitConfig.initLanguage ? this.InitConfig.initLanguage : this.languageDefault
      this.SET_LANGUAGEDEFAULT(lang)
    }
    // }
    this.$i18n.locale = this.languageDefault

    this.changeThemeLight()
  },
  watch: {
    isUSTWall: {
      handler (val) {
        if (!val) {
          let copy = document.getElementById('copy')
          let pdf = document.getElementById('pdf')
          if (!copy || !pdf) {
            return
          }
          if (this.$i18n.locale === 'en' || this.$i18n.locale === 'ja' || this.$i18n.locale === 'zh') {
            copy.classList.remove('special_width')
            pdf.classList.remove('special_width')
          } else {
            copy.classList.add('special_width')
            pdf.classList.add('special_width')
          }
        }
      }
    }
  },
  methods: {
    getDate () {
      let dt = new Date()
      let strDt = dt.getFullYear().toString()
      // strDt += dt.getMonth() + 1 > 9 ? (dt.getMonth() + 1).toString() : '0' + (dt.getMonth() + 1)
      // strDt += dt.getDate() > 9 ? dt.getDate().toString() : '0' + dt.getDate()

      return strDt
    },

    languagechange (val) {
      let divSearch = document.getElementById('tab-Search')
      // let divCategolies = document.getElementById('tab-Categolies')
      let divSpecification = document.getElementById('tab-Specification')
      let divInstallCondition = document.getElementById('tab-InstallCondition')
      let divBlending = document.getElementById('tab-Blending')
      let copy = document.getElementById('copy')
      let pdf = document.getElementById('pdf')
      let headertitle = document.getElementById('header_title')
      switch (val) {
        case 'el':
          if (divSearch) {
            divSearch.style.width = '280px'
          }
          break
        case 'fr':
        case 'ro':
          if (divBlending) {
            divBlending.style.width = '300px'
          }
          break
        case 'it':
          if (divInstallCondition) {
            divInstallCondition.style.width = '250px'
          }
          break
        case 'ru':
          if (divSpecification && divBlending) {
            divSpecification.style.width = '250px'
            divBlending.style.width = '330px'
          }
          break
        default:
          if (divSearch && divBlending && divInstallCondition && divSpecification) {
            divSearch.style.width = '200px'
            divBlending.style.width = '200px'
            divInstallCondition.style.width = '200px'
            divSpecification.style.width = '200px'
          }
          break
      }

      if (!this.isUSTWall && copy && pdf) {
        if (val === 'en' || val === 'ja' || val === 'zh') {
          copy.classList.remove('special_width')
          pdf.classList.remove('special_width')
        } else {
          copy.classList.add('special_width')
          pdf.classList.add('special_width')
        }
      }
      if (headertitle !== null) {
        if (val === 'es' || val === 'sv' || val === 'el') {
          headertitle.style.fontSize = '22px'
        } else {
          headertitle.style.fontSize = '25px'
        }
      }
      this.$i18n.locale = val
    },

    changeThemeLight (val) {
      this.themeLight = true
      this.themeDark = false
      this.SET_THEME('light')
    },

    changeThemeDark (val) {
      this.themeLight = false
      this.themeDark = true
      this.SET_THEME('dark')
    },

    homebut () {
      if (this.$route.name === 'top') {
        return false
      } else {
        return true
      }
    },

    ...mapMutations([
      'SET_THEME', 'SET_LANGUAGEDEFAULT'
    ])
  }
}
</script>

<style scoped>
.header-version {
  font-size: 12px;
  margin-left: 15px;
  float: left;
  line-height: 70px;
}
.header-title {
  font-size: 16px;
  font-weight: bold;
  float: left;
  line-height: 70px;
}

.wrap-header {
  padding: 0px;
}

.wrap__img-epson {
  margin-top: 15px;
  background-repeat: no-repeat;
  background-size: cover;
}

.wrap__img-epson {
  float: left;
}

.header-title span {
  color: #262626;
  margin-left: 20px;
}

.wrap__language {
  float: right;
  width: 140px;
  height: 70px;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue